import styled from "styled-components";
const ClearFloat = styled.div`
  clear: both;
`;
export default ClearFloat;
